import config from '@/config';
import { LINK } from '@/constants/link';
import { Modal, Text } from '@shopify/polaris';
import { useEffect, useRef, useState } from 'react';

interface IProps {
  defaultOpen?: boolean;
  usage: number;
}

const USAGE_THRESHOLD = 25;

const ModalReview = ({ defaultOpen = false, usage = 0 }: IProps) => {
  const [open, setOpen] = useState(!!defaultOpen);
  const timeoutIdRef = useRef<NodeJS.Timeout | null>(null);

  const isShow = usage >= USAGE_THRESHOLD;
  const cacheKey = `sync_paypal_wix_review_${config?.instanceId || ''}`;

  useEffect(() => {
    const isShowedReview = localStorage.getItem(cacheKey);
    if (isShowedReview === 'true') {
      return;
    }
    if (isShow) {
      timeoutIdRef.current = setTimeout(() => {
        setOpen(true);
        localStorage.setItem(cacheKey, 'true');
      }, 1000);
    }
    return () => {
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }
    };
  }, [cacheKey, isShow]);

  return (
    <Modal title="" titleHidden open={open} onClose={() => setOpen(false)}>
      <Modal.Section>
        <Text alignment="center" as="h3" variant="headingMd">
          Hurray! You have used Synctrack PayPal Tracking Sync!
        </Text>
        <div className="mt-8">
          <iframe
            src={LINK.reviewLink}
            title="Review paypal app iframe"
            width="100%"
            height="570px"
            style={{ border: '1px solid #E0E0E0', borderRadius: '12px' }}
          ></iframe>
        </div>
      </Modal.Section>
    </Modal>
  );
};

export default ModalReview;
